import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Product } from '@vestiaire/api-sdk-angular';

@Component({
  selector: 'vc-product-main-heading',
  templateUrl: './product-main-heading.component.html',
  styleUrls: ['./product-main-heading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductMainHeadingComponent {
  @Input()
  product: Product;
}
